import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  showFloorPlanTimers: attr(Boolean),
  useTableInactivityIndicators: attr(Boolean),
  tableIndicatorWarningTime: attr(Number),
  tableIndicatorAlertTime: attr(Number)
});